import { createAsset } from '@/organisms/AngelPlayer'
import type { Torch } from '@/services/TorchesService'

interface UseTorchAssetParameters {
  torch?: Torch
  name: string
  poster?: string
  subtitle: string
  slug: string
  videoType: 'torch'
}

export const useTorchAsset = ({ torch, name, poster, subtitle, slug, videoType }: UseTorchAssetParameters) => {
  if (!torch) return null

  return createAsset({
    name,
    subtitle,
    slug,
    videoType,
    guid: torch.id,
    url: torch.pitchUrl,
    poster: poster || torch.posterCloudinaryPath,
    title: '',
    description: torch.description,
    position: 0,
  })
}
